














































































import store from '@/store'
import ApiClient from '@/js/api.js'
import Global from '@/js/global.js'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import NormalButton from '@/views/atoms/NormalButton.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import DeleteButton from '@/views/atoms/DeleteButton.vue'
import ManageSubTitle from '@/views/atoms/ManageSubTitle.vue'
import ManageRow from '@/views/organisms/ManageRow.vue'
import ManageBase from '@/views/organisms/ManageBase.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import ConfirmPopup from '@/views/molecules/ConfirmPopup.vue'
import CartButtonArea from '@/views/molecules/CartButtonArea.vue'
import CartPankuzu from '@/views/molecules/CartPankuzu.vue'
import CartPriceArea from '@/views/molecules/CartPriceArea.vue'
import CartTemplate from '@/views/templates/CartTemplate.vue'

export default
  name: 'RegiConfirm'

  components: {
    Pankuzu
    Title
    NormalButton
    YellowButton
    BackButton
    DeleteButton
    ManageSubTitle
    ManageRow
    ManageBase
    ManageTemplate
    ConfirmPopup
    CartButtonArea
    CartPankuzu
    CartPriceArea
    CartTemplate
  }

  data: () ->
    sendDetail: null
    priceData: {}
    cartData:
      order_list: []
      plan_list: []
    prefID: '0'
    point: 0
    usePoint: @$route.query.point

  created: () ->
    store.dispatch('initPostParam')
    @$emit('set_color', true)
    api = new ApiClient()
    data = await api.get('/member/sendplace/detail/' + @$route.query.place)
    prefList = await store.getters.prefList
    for key, row of prefList
      if key == data.detail.prefecture_id
        @prefID = key
        data.detail.prefecture = row
        break
    if data.detail.id == ''
      @$router.push '/regi'
    @sendDetail = data.detail
    data = await api.get('/member/cart/list')
    @cartData = data.list

  computed: {
    pay_name: () ->
      for key, row of Global.getPayStyles()
        if key == @$route.query.pay
          return row
      @$router.push '/regi'
      return ''
  }

  methods: {
    go_regi: (e) ->
      @$router.push '/regi'
    go_cart: (val) ->
      @$router.push '/cart'
    go_buy: (val) ->
      api = new ApiClient()
      param =
        send_place: @$route.query.place
        pay_style: @$route.query.pay
        use_point: @$route.query.point
      data = await api.post('/member/purchase/save', true, param)
      if data.errors != null
        alert(data.errors.system[0])
        return
      store.dispatch('addCartNum', 0)

      try
        ga('require', 'ecommerce')
        ga('ecommerce:addTransaction', {
          'id': data.order_id
        })
        for cart in cartData.order_list
          ga('ecommerce:addItem', {
            'id': data.order_id
            'name': cart.item_name
            'category': cart.store_name
            'price': cart.price
            'quantity': cart.count
          })
        ga('ecommerce:send')
      catch e
        console.log e

      if data.url
        location.href = data.url
      #@$router.push '/regi/end'
    set_point: (val) ->
      @point = val
    tax: (price) ->
      Global.tax price
    comma: (price) ->
        Global.comma price
  }
